<div class="flex-col height100p">
    <p-message styleClass="mb-2" severity="danger" [text]="app.t('customers.formeld.personellFile.oldDataIncomplete')"></p-message>
    <p-tabView class="flex-item-fill full-height" [(activeIndex)]="activeTabIndex" (activeIndexChange)="changeActiveTabIndex()">
        <p-tabPanel [header]="app.t('customers.formeld.personellFile.tabDocuments')">
            <div class="height100p flex-col">
                <app-enaio-documents-definition #defComponent class="flex-item-fill" [embeddedComponent]=true [defId]="selectedDocumentType">
                    @if (personellGui?.length > 0) {
                        <span>{{app.t('customers.formeld.personellFile.title')}}: <p-dropdown class="ml-1 mr-2" [styleClass]="'width200'" [options]="personellGui" [(ngModel)]="selectedPersonell" (onChange)="changePersonell()"></p-dropdown></span>
                    }
                    @if (documentTypesGui?.length > 0) {
                        <span>{{app.t('customers.formeld.personellFile.documentType')}}: <p-dropdown class="ml-1" [styleClass]="'width300'" [options]="documentTypesGui" [(ngModel)]="selectedDocumentType" (onChange)="change()"></p-dropdown></span>
                    }
                </app-enaio-documents-definition>
            </div>
        </p-tabPanel>
        <p-tabPanel [header]="app.t('customers.formeld.personellFile.tabCalendar')">
            @if(inited) {
                <div class="height100p flex-col">
                    <p-toolbar>
                        <div class="p-toolbar-group-start">
                            <p-selectButton [options]="calendarViews" optionLabel="label" optionValue="value" [allowEmpty]=false [(ngModel)]="selectedCalendarView" (ngModelChange)="changeCalendarView()"/>
                        </div>
                        <div class="p-toolbar-group-center">
                            <button pButton class="mr-3" icon="fas fa-chevron-left" (click)="calendarScroll(-1)"></button>
                            <span class="text-xl bold width200 text-center">{{calendarTitle}}</span>
                            <button pButton class="ml-3" icon="fas fa-chevron-right"(click)="calendarScroll(1)"></button>
                        </div>
                        <div class="p-toolbar-group-end">
                        </div>
                    </p-toolbar>
                    <div class="flex-item-fill flex-row-split">
                        <p-panel class="flex-item-fixed width300 full-height mt-3" [header]="app.t('general.filter')">
                            <div class="width100p height100p flex-col">
                            <span class="mt-3">{{app.t('customers.formeld.personellFile.calendar.eventTypes')}}</span>
                            <p-listbox class="mt-2"
                                [options]="eventTypes"
                                [checkbox]=true
                                [multiple]=true
                                [(ngModel)]="calendarSelectedEventTypes"
                                (onChange)="updateCalendarFilter()"
                            >
                            </p-listbox>
                            <span class="mt-3">{{app.t('customers.formeld.personellFile.calendar.employees')}}</span>
                            <p-listbox class="flex-item-fill full-height mt-2"
                                [options]="employeesGui"
                                [checkbox]=true
                                [multiple]=true
                                [(ngModel)]="calendarSelectedEmployees"
                                (onChange)="updateCalendarFilter()"
                            >
                            </p-listbox></div>
                        </p-panel>
                        <full-calendar #fc class="width100p height100p flex-item-fill" [options]="calendarOptions"></full-calendar>
                    </div>
                </div>
            }
        </p-tabPanel>
    </p-tabView>
</div>